import { CAREER_PORTAL_URL } from '@/creditflowresearch/ui/common/components/templates/HeaderLayout/headerLinksConfig';
import staticUrls from '@finsight/urls/static';
import drsUrl from '@drs/url';
import evercallUrl from '@evercall/url';
import { dataroomUrl } from '@dataroom/url';
import URL from '@/creditflowresearch/Router/urlConstants';
import dataroomConfig from '@dataroom/config';
import creditFlowConfig from '@creditflowresearch/config';
import { IFooter } from '@/creditflowresearch/domain/vo/IFooter';
import cfrUrl from '@/creditflowresearch/infrastructure/url';

import styles from '@/creditflowresearch/ui/common/components/Footer/footer.module.scss';

const classNames = {
  columnTitleClassName: styles.columnTitle,
  panelClassName: styles.panel,
  arrowClassName: styles.panelArrow,
  columnClassName: styles.column,
};

export const footerCollection: IFooter = {
  navigation: [
    {
      path: staticUrls.getComplianceUrl(),
      title: 'Compliance',
      shouldOpenInNewTab: true,
    },
    {
      path: staticUrls.getPrivacyPolicyUrl(),
      title: 'Privacy',
      shouldOpenInNewTab: true,
    },
    {
      path: staticUrls.getSecurityPolicyUrl(),
      title: 'Security',
      shouldOpenInNewTab: true,
    },
    {
      path: staticUrls.getTermsOfUseUrl(),
      title: 'Terms',
      shouldOpenInNewTab: true,
    },
  ],
  content: [
    {
      key: 'company',
      title: 'Company',
      ...classNames,
      collection: [
        {
          title: 'About',
          path: staticUrls.getAboutUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Careers',
          path: staticUrls.getCareersUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Contact',
          path: staticUrls.getContactUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Solutions',
          path: staticUrls.getSolutionsUrl(),
          shouldOpenInNewTab: true,
        },
      ],
    },
    {
      key: 'creditflow',
      title: 'CreditFlow',
      ...classNames,
      collection: [
        { title: 'API Overview', path: URL.EXTERNAL_API },
        // TODO: use API docs page is ready
        { title: 'API Documentation', path: URL.EXTERNAL_API_DOCS, shouldOpenInNewTab: true, linkClassName: styles.apiDocsLink },
        { title: 'Global Issuers List', path: URL.ISSUERS_LIST },
        { title: 'Global Parents List', path: URL.SPONSORS_LIST },
        { title: 'Pricing', path: URL.PRICING },
        { title: 'OpenMarket Profiles', path: cfrUrl.getUrl(URL.OPEN_MARKET) },
      ],
    },
    {
      key: 'products',
      title: 'Products',
      ...classNames,
      collection: [
        {
          title: 'Career Portal',
          path: CAREER_PORTAL_URL,
          shouldOpenInNewTab: true,
        },
        {
          title: 'CapEdge',
          // @todo: move this to config and create separate tenant in docker and MG
          path: 'https://capedge.com',
          shouldOpenInNewTab: true,
        },
        {
          title: 'CreditFlow',
          path: cfrUrl.getUrl('/'),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Deal Roadshow',
          path: drsUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'DealVDR',
          path: dataroomUrl(dataroomConfig.dealvdr.code).getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Evercall',
          path: evercallUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'More',
          path: staticUrls.getSolutionsUrl(),
          shouldOpenInNewTab: true,
        },
      ],
    },
    {
      key: 'sales',
      title: 'Sales & Support',
      ...classNames,
      collection: [
        { title: 'Americas', phoneNumber: '+1 888 997 6610 ' },
        { title: 'APAC', phoneNumber: '+852 3018 1600' },
        { title: 'EMEA', phoneNumber: '+44 80817 87364' },
        {
          title: `${ creditFlowConfig.supportEmail }`,
          path: `mailto:${ creditFlowConfig.supportEmail }?subject=Finsight Sales %26 Support Request`,
          linkClassName: styles.supportEmailLink,
        },
      ],
    },
  ],
};
